import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './IntroPage.css';

function IntroPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [checkingMaintenance, setCheckingMaintenance] = useState(true);

  const navigate = useNavigate();

  // Public & Admin credentials (exact match)
  const PUBLIC_USER = 'Popcorn';
  const PUBLIC_PASS = '&Peanuts';
  const ADMIN_USER = 'Admin';
  const ADMIN_PASS = 'letmein';

  // Deployment-friendly backend URL
  const backendBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost'
      ? 'http://localhost:5001'
      : 'https://pickem-backend-2025.onrender.com');

  useEffect(() => {
    let mounted = true;

    const checkMaintenanceMode = async () => {
      try {
        const res = await fetch(`${backendBase}/api/maintenance-mode`, {
          cache: 'no-store'
        });

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();

        if (mounted) {
          setMaintenanceMode(Boolean(data.maintenanceMode));
        }
      } catch (err) {
        console.error('Could not check maintenance mode:', err);

        // Fail open so a temporary status-check problem
        // does not lock players out of the site.
        if (mounted) {
          setMaintenanceMode(false);
        }
      } finally {
        if (mounted) {
          setCheckingMaintenance(false);
        }
      }
    };

    checkMaintenanceMode();

    return () => {
      mounted = false;
    };
  }, [backendBase]);

  const handleLogin = () => {
    setError('');

    const isPublic =
      username === PUBLIC_USER && password === PUBLIC_PASS;

    const isAdmin =
      username === ADMIN_USER && password === ADMIN_PASS;

    // Admin access always remains available.
    if (isAdmin) {
      navigate('/admin-tools');
      return;
    }

    // Public entry is suspended while Test Mode is active.
    if (isPublic) {
      if (maintenanceMode) {
        setError(
          'This page is temporarily suspended while testing is in progress. Please try again later.'
        );
        return;
      }

      navigate('/home');
      return;
    }

    setError('Incorrect username or password');
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div className="intro-container">
      <h1 className="intro-title">
        Welcome to Shama-Lama Football Challenge
      </h1>

      {maintenanceMode && !checkingMaintenance && (
        <div
          style={{
            maxWidth: 520,
            margin: '0 auto 20px auto',
            padding: 14,
            border: '2px solid #b91c1c',
            borderRadius: 6,
            background: '#fdeaea',
            color: '#8a1f1f',
            fontWeight: 700,
            textAlign: 'center'
          }}
        >
          TEST MODE ACTIVE
          <div
            style={{
              marginTop: 6,
              fontWeight: 500
            }}
          >
            This page is temporarily suspended while testing is in progress.
            Please try again later.
          </div>
        </div>
      )}

      <div className="login-box">
        <h2>
          {maintenanceMode
            ? 'Admin Access'
            : 'Enter UserID and Password'}
        </h2>

        <input
          type="text"
          placeholder="UserID"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={onKeyDown}
          autoComplete="username"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={onKeyDown}
          autoComplete="current-password"
        />

        <button
          onClick={handleLogin}
          disabled={checkingMaintenance}
        >
          {checkingMaintenance ? 'Checking...' : 'Enter'}
        </button>

        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}

export default IntroPage;